var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.msg),expression:"msg"}],staticClass:"a-fadeout",attrs:{"id":"component-swert"},domProps:{"textContent":_vm._s(_vm.msg)}})}
var staticRenderFns = []

export { render, staticRenderFns }